module.exports = "<div class=\"saving\"><h3>.</h3><h3>.</h3><h3>.</h3></div>\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/loading-ellipsis/loading-ellipsis.component.html
// module id = ../../../../../src/app/loading-ellipsis/loading-ellipsis.component.html
// module chunks = main